











































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Input from '@/components/inputs/Input.vue'
import Select from '@/components/Select.vue'
import PaymentMethods from '@/views/app/management/components/PaymentMethods.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import Recipients from '@/views/app/management/components/Recipients.vue'
import PayerTypes from '@/views/app/payment/components/PayerTypes.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { ISelectItem } from '@/interfaces'
import {
  EAutoPayItemStatus,
  EFacilityPayerTypePaymentOrder,
  EPaymentReceiptType,
  IAutoPayItem,
  IPayerType,
  IResidentContact,
  IResidentPaymentMethod,
  isBoolean
} from '@zunta/configurations'
import Card from '@/components/Card.vue'
import PaymentSurcharge from '@/views/app/payment/components/PaymentSurcharge.vue'
import { EAutoPayOffset, EAutoPaySettingStatus, EAutoPayType, IAutoPaySetting } from '@zunta/configurations/dist/types/payments'
import { User } from '@/classes/User'
import Api from '@/api'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { NoCache } from '@/decorators/NoCache'
import { FacilityModule } from '@/store/modules/facility.module'
import MoneyInputV3 from '@/components/inputs/MoneyInputV3.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import RadioButton from '@/components/RadioButton.vue'
import TableHeadFilters from '@/components/tables/TableHeadFilters.vue'

const range = require('lodash.range')
const moment = require('moment')
const uniqBy = require('lodash.uniqby')

@Component({
  name: 'Autopay',
  components: {
    Checkbox,
    PaymentSurcharge,
    Card,
    PayerTypes,
    Recipients,
    Icon,
    Select,
    Input,
    SearchInput,
    PaymentMethods,
    DateInput2,
    RadioGroup,
    ErrorMessages,
    MoneyInputV3,
    RadioButton
  }
})
export default class Autopay extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EPaymentReceiptType: any = EPaymentReceiptType
  EAutoPayOffset: any = EAutoPayOffset
  EAutoPayType: any = EAutoPayType
  user: User = Api.getUser() as User
  autoPayData: Partial<IAutoPaySetting> = {
    resident: this.residentId,
    autoPayType: undefined,
    amount: 0,
    needsReview: undefined,
    appliedTo: {
      useDefault: true,
      payerTypes: []
    },
    paymentMethod: 0,
    firstPaymentDate: new Date(Date.now() + 24 * 60 * 60 * 1000),
    dayOfMonth: undefined,
    includeSurcharge: false,
    includeECheckSurcharge: false,
    duration: 0,
    offset: EAutoPayOffset.CURRENT_MONTH,
    includePrebillCharges: false
  }
  isPaymentAmountLimited: boolean = false
  warnings: { [key: string]: string } = {}
  invalidFirstPaymentDate: boolean = false
  errors: string[] = []
  isSaving: boolean = false

  @NoCache
  get isEdit () {
    return this.$route.name === 'edit-payment-autopay'
  }

  get reviewPaymentListItems () {
    return [{
      key: 'true',
      value: true,
      content: 'Yes'
    },
      {
        key: 'false',
        value: false,
        content: 'No'
      }
    ]
  }

  get durationListItems (): ISelectItem[] {
    const values: ISelectItem[] = [{
      key: 'duration-ongoing',
      value: 0,
      content: 'Ongoing'
    }]

    for (let i = 1; i < 25; i++) {
      values.push({
        key: `duration-${i}`,
        value: i,
        content: `${i}`
      })
    }

    return values
  }

  get offsetItems (): ISelectItem[] {
    return [
      {
        key: 'prev',
        value: EAutoPayOffset.PREVIOUS_MONTH,
        content: 'Previous Month'
      },
      {
        key: 'current',
        value: EAutoPayOffset.CURRENT_MONTH,
        content: 'Current Month'
      },
      {
        key: 'next',
        value: EAutoPayOffset.NEXT_MONTH,
        content: 'Next Month'
      }
    ]
  }

  get typeRadioOptions (): ISelectItem[] {
    return [
      {
        key: EAutoPayType.BILL_MAX_ONLY,
        value: EAutoPayType.BILL_MAX_ONLY,
        content: 'Charge account balance'
      },
      {
        key: EAutoPayType.BILL_ANYWAY,
        value: EAutoPayType.BILL_ANYWAY,
        content: 'Charge flat amount (if balance at time of payment is 0, payment will be credited to future charges)'
      },
      {
        key: EAutoPayType.BILL_MONTH_DUE,
        value: EAutoPayType.BILL_MONTH_DUE,
        content: 'Charge balance of month'
      }
      // {
      //   key: EAutoPayType.BILL_FULL_DUE,
      //   value: EAutoPayType.BILL_FULL_DUE,
      //   content: 'Bill full account balance'
      // }
    ]
  }

  get applySettingsListItems (): ISelectItem[] {
    return [
      {
        key: 'customPayerTypeFalse',
        value: true,
        content: 'Use Default Settings'
      },
      {
        key: 'customPayerTypeTrue',
        value: false,
        content: 'Custom'
      }
    ]
  }

  get residentId () {
    return Number(this.$route.params.residentId)
  }

  get settingId () {
    return Number(this.$route.params.settingId)
  }

  get monthDaysListItems () {
    const list = []
    for (let i = 1; i < 32; i++) {
      const label = i < 29 ? i : `${i} or last month day`
      list.push({
        key: i,
        value: i,
        content: label
      })
    }

    return list
  }

  get currentSettings () {
    return this.$store.state.payments.currentAutoPaySetting
  }

  get residentContacts () {
    return this.$store.state.resident.residentContacts.filter((item: IResidentContact) => !!item.email)
  }

  get availableMailRecipients () {
    return uniqBy([
      ...(
          this.currentSettings &&
          this.currentSettings.receiptTo &&
          this.currentSettings.receiptTo.length
              ? this.currentSettings.receiptTo.map((item: any) => {
                return { ...item, checked: true }
              })
              : []
      ),
      ...this.residentContacts.map((item: IResidentContact) => {
        return {
          ...item,
          checked: false
        }
      })
    ], 'email')
  }

  get payerTypes () {
    return this.$store.state.facility.payerTypes ? this.$store.state.facility.payerTypes : []
  }

  get activePayerTypes () {
    return this.payerTypes.filter((payerType: IPayerType) => payerType.active)
  }

  get storePayerTypeSettings () {
    return this.$store.state.facility.payerTypePaymentSettings
  }

  get storeDefaultPayerTypeSettings () {
    if (!this.storePayerTypeSettings || !this.storePayerTypeSettings.length) {
      return this.activePayerTypes.map((item: any) => {
        return {
          ...item,
          paymentOrder: EFacilityPayerTypePaymentOrder.NEWEST
        }
      })
    }
    return this.storePayerTypeSettings
        .filter((item: any) => !item.dontAutoApply)
        .map((item: any) => {
          const existingItem = this.activePayerTypes.find((activePayer: any) => item.payerType === activePayer.id)
          return {
            ...existingItem,
            paymentOrder: item.paymentOrder
          }
        })
  }

  get availablePayerTypes () {
    const selected = (this.currentSettings &&
    this.currentSettings.appliedTo &&
    this.currentSettings.appliedTo.payerTypes.length
        ? this.currentSettings.appliedTo.payerTypes.map((item: any) => {
          return { ...item, checked: true }
        })
        : [])
    const available = this.storeDefaultPayerTypeSettings.map((item: any) => {
      return {
        payerType: item.id,
        payerName: item.payer_name,
        paymentOrder: item.paymentOrder,
        checked: false
      }
    })
    const concat = [...selected, ...available]
    return uniqBy(concat, 'payerType')
  }

  get facility () {
    return typeof this.$store.state.resident.selectedResident.facility === 'number'
        ? this.$store.state.resident.selectedResident.facility
        : this.$store.state.resident.selectedResident.facility.id
  }

  get autopayItems () {
    return this.$store.state.payments.autoPayItems
  }

  setInvalidFirstPaymentDate (error: boolean) {
    this.invalidFirstPaymentDate = error
  }

  async mounted () {
    await this.facilityModuleInstance.fetchPayerTypes(this.facility)
    await this.facilityModuleInstance.fetchFacilityAutoApplySettings(this.facility)
    if (this.isEdit) {
      await this.fetchAutoPaySetting()
      await this.fetchAutoPayItems()
      if (!this.currentSettings) { return }
      const appliedTo = this.currentSettings.appliedTo.payerTypes && this.currentSettings.appliedTo.payerTypes.length
          ? this.currentSettings.appliedTo.payerTypes.map((item: any) => {
            return {
              ...item,
              checked: true
            }
          })
          : []
      const receiptTo = this.currentSettings.receiptTo && this.currentSettings.receiptTo.length
          ? this.currentSettings.receiptTo.map((item: any) => {
            return {
              ...item,
              checked: true
            }
          })
          : []

      const type = this.currentSettings.autoPayType === EAutoPayType.BILL_FULL_DUE && Number(this.currentSettings.amount) === 0
          ? EAutoPayType.BILL_MAX_ONLY
          : this.currentSettings.autoPayType

      if (Number(this.currentSettings.amount)) {
        this.isPaymentAmountLimited = true
      }

      this.autoPayData = {
        ...this.currentSettings,
        firstPaymentDate: moment(this.currentSettings.firstPaymentDate).toDate(),
        autoPayType: type,
        receiptTo: receiptTo,
        appliedTo: {
          payerTypes: appliedTo,
          useDefault: this.currentSettings.appliedTo.useDefault
        }
      }
    }
  }

  destroyed () {
    this.paymentsModuleInstance.resetCurrentAutoPaySetting()
  }

  async fetchAutoPaySetting () {
    await this.paymentsModuleInstance.fetchAutoPaySetting(this.settingId)
  }

  setPaymentMethod (paymentMethod: IResidentPaymentMethod | number) {
    if (!paymentMethod) {
      this.setAutoPayProp('paymentMethod', null)
    } else if (typeof paymentMethod === 'number') {
      this.setAutoPayProp('paymentMethod', paymentMethod)
    } else if (paymentMethod && paymentMethod.id) {
      this.setAutoPayProp('paymentMethod', paymentMethod.id)
    }
  }

  setAutoPayProp (key: string, value: any) {
    this.settingId && this.checkForWarnings(key, value)
    this.$set(this.autoPayData, key, value)
  }

  checkForWarnings (key: string, value: string | number) {
    this.warnings = {}
    const firstPaymentDate = this.autoPayData.firstPaymentDate
    switch (key) {
      case 'dayOfMonth':
        if (value === moment().date() && firstPaymentDate && firstPaymentDate < moment()) {
          this.warnings[key] = `The first payment after this change will be on ${moment().add(1, 'months').format('MMMM')} ${value}`
        }
        break
    }
  }

  updateAppliedPayerTypes (selectedPayerTypes: any[]) {
    // @ts-ignore
    this.autoPayData.appliedTo.payerTypes = [...selectedPayerTypes]
  }

  formatDate (date: Date) {
    return moment(date).format('MM/DD/YYYY')
  }

  validate () {
    this.errors = []

    if (!this.autoPayData.autoPayType) {
      this.errors.push('Select Autopay type')
    }

    if (!this.autoPayData.paymentMethod) {
      this.errors.push('Select Payment Method')
    }

    if (
      (!this.autoPayData.amount || this.autoPayData.amount < 0) && (this.autoPayData.autoPayType === EAutoPayType.BILL_ANYWAY || (
          this.autoPayData.autoPayType === EAutoPayType.BILL_MAX_ONLY && this.isPaymentAmountLimited
      ))
    ) {
      this.errors.push('Invalid Amount')
    }

    if (this.canEditFirstPaymentDate) {
      if (!this.autoPayData.firstPaymentDate || this.invalidFirstPaymentDate) {
        this.errors.push('Invalid First Payment Date')
      } else if (this.autoPayData.firstPaymentDate <= new Date()) {
        this.errors.push('First Payment date must be after Today')
      }
    }

    if (!this.autoPayData.dayOfMonth) {
        this.errors.push('Select Scheduled Monthly Payment Date')
    }

    if (!isBoolean(this.autoPayData.needsReview)) {
        this.errors.push('Select Review payment before it is processed')
    }

    const appliedTo = this.autoPayData.appliedTo
    if (!appliedTo || (!appliedTo.useDefault && (!Array.isArray(appliedTo.payerTypes) || !appliedTo.payerTypes.length))) {
      this.errors.push('Select Payers for Custom Applied To')
    }

    return this.errors.length === 0
  }

  async save () {
    if (!this.validate() || this.isSaving) {
      return
    }
    this.isSaving = true
    this.$eventBus.$emit('loading:enable', { message: 'Sending' })
    const autoPayData = { ...this.autoPayData }

    if (autoPayData.autoPayType === EAutoPayType.BILL_MAX_ONLY && Number(autoPayData.amount) <= 0) {
      autoPayData.autoPayType = EAutoPayType.BILL_FULL_DUE
    }
    const response: any = await this.residentModuleInstance.saveAutoPayment({
      residentId: this.residentId,
      data: {
        ...autoPayData,
        // @ts-ignore
        amount: this.autoPayData.amount ? Number(this.autoPayData.amount).toFixed(2) : 0,
        firstPaymentDate: moment(this.autoPayData.firstPaymentDate).format('YYYY-MM-DD')
      }
    })
    this.isSaving = false
    this.$eventBus.$emit('loading:disable')
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message || 'Something went wrong',
        header: `Create Autopayment`,
        icon: 'warning'
      })
      return
    }
    this.$router.push({
      name: 'payment-autopay-success',
      params: {
        residentId: String(this.residentId),
        scheduleId: response.id.toString()
      }
    })
  }

  async fetchAutoPayItems () {
    await this.paymentsModuleInstance.fetchAutoPayItems(this.settingId)
  }

  get canEditFirstPaymentDate () {
    if (!this.isEdit) {
      return true
    }
    if (
      this.currentSettings &&
      this.currentSettings.firstPaymentDate &&
      new Date(this.currentSettings.firstPaymentDate) <= new Date()
    ) {
      return false
    }
    if (this.autopayItems && this.autopayItems.length) {
      const notUpcomingPayment = this.autopayItems.find((p: IAutoPayItem) => p.status !== EAutoPayItemStatus.UPCOMING)
      return !notUpcomingPayment
    }
    return true
  }

  isActive (itemValue: EAutoPayType): boolean {
    return itemValue === this.autoPayData.autoPayType
  }

  setIsPaymentAmountLimited (val: boolean) {
    this.isPaymentAmountLimited = val
  }

  resetSettings (): void {
    this.setAutoPayProp('amount', 0)
    this.setAutoPayProp('includePrebillCharges', false)
    this.setIsPaymentAmountLimited(false)
  }

  get maxFirstPaymentDate () {
    return moment().add(100, 'years').endOf('month').toDate()
  }
}

